import React from 'react'
import { Form as RsForm, Row, Col, Label } from 'reactstrap'
import { Select } from 'components/select'
import { Validator } from 'components/validation'
import { AddItemButton } from 'components/buttons'
import { Input } from 'components/inputs'
import { dialogTypes } from 'dialogs'
import { api as countriesApi } from 'store/modules/lookups/countries'
import { formatDate } from 'utils/dateUtilities'
import { formatCurrency } from 'utils/numberUtilities'
import { Icon } from 'components/icons'
import { ContactForm } from 'components/contactForm'
import { useStyles } from './form.css'

const Form = (props) => {
  const classes = useStyles()
  const { disabled, data, updateEntity, localize } = props
  const { entity } = data
  if (!entity) { return null }
  return (
    <RsForm>
      <Row>
        <Col sm='6'>
          <Label>{localize('common.name')}</Label>
          <Validator name='name' value={entity.name} required maxLength={255} disabled={disabled}>
            <Input value={entity.name} onChange={updateEntity('name')} placeholder={localize('common.name')} disabled={disabled} />
          </Validator>
        </Col>
        <Col sm='6'></Col>
      </Row>
      <Row><Col><hr /></Col></Row>
      <ContactForm entity={entity} updateEntity={updateEntity} localize={localize} disabled={disabled} />
      <Row>
        <Col sm={6}>
          <Label>{localize('suppliers.country')}</Label>
          <AddItemButton dialogType={dialogTypes.countryDetail} disabled={disabled} onCreatedEntity={updateEntity('country')}>
            <Validator name='country' value={entity.country} required disabled={disabled}>
              <Select
                dataSource={countriesApi.get}
                value={entity.country}
                onChange={updateEntity('country')}
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
        <Col sm={6}>
          <Label>{localize('suppliers.taxIdentificationNumber')}</Label>
          <Validator name='taxIdentificationNumber' value={entity.taxIdentificationNumber} maxLength={50} disabled={disabled}>
            <Input value={entity.taxIdentificationNumber} onChange={updateEntity('taxIdentificationNumber')} placeholder={localize('suppliers.taxIdentificationNumber')} disabled={disabled} />
          </Validator>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <Label>{localize('suppliers.bankAccount')}</Label>
          <Validator name='bankAccount' value={entity.bankAccount} maxLength={100} disabled={disabled}>
            <Input value={entity.bankAccount} onChange={updateEntity('bankAccount')} placeholder={localize('suppliers.bankAccount')} disabled={disabled} />
          </Validator>
        </Col>
        <Col sm={6}>
          <Label>{localize('suppliers.phoneNumber')}</Label>
          <Validator name='phoneNumber' value={entity.phoneNumber} maxLength={50} disabled={disabled}>
            <Input value={entity.phoneNumber} onChange={updateEntity('phoneNumber')} placeholder={localize('suppliers.phoneNumber')} disabled={disabled} />
          </Validator>
        </Col>
      </Row>
      <Row className={classes.row}>
        <Col sm={12}>
          <Label>{localize('suppliers.comment')}</Label>
          <Validator name='comment' value={entity.comment} disabled={disabled}>
            <Input type={'textarea'} rows={5} value={entity.comment} onChange={updateEntity('comment')} placeholder={localize('suppliers.comment')} disabled={disabled} />
          </Validator>
        </Col>
      </Row>
      <Row><Col><hr /></Col></Row>
      {props.isInDialog !== true && <Row>
        <Col sm='12'>
          <table className={classes.statistics}>
            <tbody>
              {entity.dateOfFirstOrder &&
              <tr>
                <td className={classes.iconCell}><Icon name='calendar' /></td>
                <td className={classes.labelCell}><Label>{localize('suppliers.dateOfFirstOrder')}</Label></td>
                <td className={classes.valueCell}>{formatDate(entity.dateOfFirstOrder)}</td>
              </tr>}
              <tr>
                <td className={classes.iconCell}><Icon name='glass' /></td>
                <td className={classes.labelCell}><Label>{localize('suppliers.totalBottles')}</Label></td>
                <td className={classes.valueCell}>{entity.totalBottles}</td>
              </tr>
              <tr>
                <td className={classes.iconCell}><Icon name='money' /></td>
                <td className={classes.labelCell}><Label>{localize('suppliers.totalPrice')}</Label></td>
                <td className={classes.valueCell}>{formatCurrency({ value: entity.totalPrice })}</td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>}
    </RsForm>
  )
}

export default Form